"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var forOwn = require("lodash.forown");
var camelCase = require("lodash.camelcase");
var snakeCase = require("lodash.snakecase");
var isPlainObject = require("lodash.isplainobject");
/**
 * @description walk tree
 * @param {Object | Array} obj
 * @param {Function} cb - callback
 * @returns {Object | Array}
 */
function walk(obj, cb) {
    var x = Array.isArray(obj) ? [] : {};
    forOwn(obj, function (v, k) {
        if (isPlainObject(v) || Array.isArray(v))
            v = walk(v, cb);
        x[cb(k)] = v;
    });
    return x;
}
function toCamel(obj) {
    return walk(obj, function (k) { return camelCase(k); });
}
exports.toCamel = toCamel;
;
function toSnake(obj) {
    return walk(obj, function (k) { return snakeCase(k); });
}
exports.toSnake = toSnake;
;
//# sourceMappingURL=index.js.map